export default __webpack_public_path__ + "static/media/device_ie_node.855907fb.svg";